export enum FunctionalDocumentationKeys {
	DEPOT_HEADERS_MAPPING = 'DEPOT_HEADERS_MAPPING',
	ExportTemplate__FileNamePatternPreview = 'EXPORT_TEMPLATE__FILE_NAME_PATTERN',
	EXPOSITION = 'EXPOSITION',
	EXPOSITION_FILTER_SYNTAX = 'doc/dc_funct/EXPOSITION_FILTER_SYNTAX',
}
